import ErrorPage from "next/error";
import { useRouter } from "next/router";
import React, { useRef, useEffect, useState } from "react";
import slugify from "slugify";
import { getToken } from "../../src/config/firebase";
import {
  ProfileWrap,
  ContentBox,
  ProfileOverall,
  SectionHeader,
  UserName,
  SocialLinks,
  SmallFancyBold,
  PhotoLabel,
} from "../../styles/ProfileStyles";
import {
  Avatar,
  Flex,
  Badge,
  Text,
  Button,
  Box,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  Select as ChakraSelect,
  ModalHeader,
  ModalOverlay,
  Alert,
  AlertIcon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  ButtonGroup,
  useToast,
  ModalFooter,
  Textarea,
  Input,
} from "@chakra-ui/react";
import RelevantListing from "../ListingCard/RelevantListing";
import Link from "next/link";
import Head from "next/head";
import { AuthModal } from "../Auth/withAuthModal";
import NumberFormat from "react-number-format";
import { useAuth } from "../../utils/auth/newAuth";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import styles from "../../styles/listingStyles.module.css";
import MaterialInput from "../UI/Forms/Input/MaterialInput";
import MaterialTextarea from "../UI/Forms/Input/MaterialTextarea";
import Message from "../UI/Message/Message";
import MySpinner from "../UI/Spinner/Spinner";
import prisma from "../../lib/prisma";
import SideNav from "../SideNav/SideNav";
import { useMutation, useQuery } from "react-query";
// import { Disclaimer, reactSelectOptionCreator, createSimpleArray } from '../../../utils/clientUtilties';
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillPicture,
  AiFillTwitterSquare,
} from "react-icons/ai";
import Select from "react-select";
import { industryRoleOptions, propertyTypeOptions, titleOptions } from "../Listing/data";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import { useLoadScript } from "@react-google-maps/api";
import ImageCropper from "../ImageCropper/ImageCropper";
import swal from "sweetalert";
import Spinner from "../UI/Spinner/Spinner";
import {
  Disclaimer,
  reactSelectOptionCreator,
  createSimpleArray,
  MyFormLabel,
} from "../../utils/clientUtilities";
import { CitySearch, clientAnalytics, clientError } from "../../utils/utilties";
import {
  EditIcon,
  AddIcon,
  CloseIcon,
  ArrowBackIcon,
  ArrowForwardIcon,
  ExternalLinkIcon,
  SmallCloseIcon,
  CheckIcon,
} from "@chakra-ui/icons";
import { MarginContainer } from "../../styles/SignupStyles";
import CreatableSelect from 'react-select/creatable';
import { greenTheme, selectTheme } from "../../styles/inputThemes";

const libraries = ["places"];

const profileComponent = ({ fUser }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_API_KEY,
    // @ts-ignore
    libraries,
  });
  const [profileData, setProfileData] = useState(fUser);
  const [visitTracked, setVisitTracked] = useState(false);
  const [messageToSend, setMessageToSend] = useState(false);
  const {
    firstName,
    lastName,
    fullName,
    brokerage,
    phone,
    pro,
    facebook,
    instagram,
    linkedin,
    twitter,
    uid,
    specialization,
    photoURL,
    brokeragePhoto,
    link,
    location,
    about,
    industryRole,
    title,
    welcomeAssist,
  } = profileData;
  const { Listings: ownListings,
    coListings, } = fUser;
  // const userListings = fUser['Listings']
  const router = useRouter();
  const toast = useToast();
  const userListings = [...ownListings, ...coListings]

  useEffect(() => {
    if (fUser.uid !== profileData.uid) {
      setProfileData(fUser)
      console.log('fUser', fUser)
    }
  }, [fUser])

  if (router.isFallback) {
    return <MySpinner size={"md"} />;
  }

  if (!fUser) {
    return <ErrorPage statusCode={404} />;
  }

  const { user, userId, profile } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [showPhone, setShowPhone] = useState(false);

  let scroller = useRef(null);
  const [translatePixels, SetTranslatePixels] = useState(0);
  const [allowableScroll, setAllowableScroll] = useState(2);
  const placeholder = ``;
  const [phoneNumber, setPhoneNumber] = useState("View Phone Number");
  const [isAuthBoxOpen, setIsAuthBoxOpen] = useState(false);
  const [messageStatus, setMessageStatus] = useState("idle");
  const [messageText, setMessageText] = useState(
    `Hi ${firstName}, I'd like to get in touch with you.`
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [changeStatus, setChangeStatus] = useState("idle");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editContent, setEditContent] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [picUploadStatus, setPicUploadStatus] = useState("idle");
  const [profilePictureURL, setProfilePictureURL] = useState(null);
  const [brokeragePictureURL, setBrokeragePictureURL] = useState(null);
  const [authHeader, setAuthHeader] = useState(null)
  const [brokerageFinderText, setBrokerageFinderText] = useState("");
  const [adminWelcomeAssist, setAdminWelcomeAssist] = useState(fUser.welcomeAssist);
  const [adminContactInfo, setAdminContactInfo] = useState<{ email: string | null; phone: string | null } | null>(null);
  const [adminLeadStats, setAdminLeadStats] = useState<{ leadCount: number; pro: boolean; everPro: boolean } | null>(null);
  const [deleteUserStatus, setDeleteUserStatus] = useState<'idle' | 'loading' | 'done'>('idle');
  const { isOpen: isDeleteUserOpen, onOpen: onDeleteUserOpen, onClose: onDeleteUserClose } = useDisclosure();
  const deleteUserCancelRef = useRef(null);

  useEffect(() => {
    if (profile?.userRole === "admin") {
      const fetchAdminContactInfo = async () => {
        const token = await getToken();
        const res = await fetch(`/api/users/${uid}?type=full`, {
          headers: { token },
        });
        if (res.ok) {
          const { currentUser } = await res.json();
          setAdminContactInfo({ email: currentUser.email, phone: currentUser.phone });
          setAdminLeadStats({
            leadCount: currentUser.leadCount,
            pro: currentUser.pro,
            everPro: currentUser.everPro,
          });
        }
      };
      fetchAdminContactInfo();
    }
  }, [uid, profile?.userRole]);

  useEffect(() => {
    // Only fetch if user is admin and we don't have the initial state
    if (profile?.userRole === "admin" && adminWelcomeAssist === null) {
      const fetchWelcomeAssist = async () => {
        const response = await fetch(`/api/users/${uid}/welcome-assist`);
        const data = await response.json();
        setAdminWelcomeAssist(data.welcomeAssist);
      };
      fetchWelcomeAssist();
    }
  }, [uid, profile?.userRole, adminWelcomeAssist]);

  async function handleDeleteUser() {
    onDeleteUserClose();
    setDeleteUserStatus('loading');
    try {
      const token = await getToken();
      const res = await fetch('/api/admin/delete-and-block', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', token },
        body: JSON.stringify({ targetUid: uid }),
      });
      const data = await res.json();
      if (res.ok) {
        toast({
          title: 'User deleted',
          description: `Removed ${data.deletedListings} listing(s) and all associated data.`,
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        setDeleteUserStatus('done');
        router.push('/');
      } else {
        toast({ title: 'Error', description: data.error, status: 'error', duration: 5000, isClosable: true });
        setDeleteUserStatus('idle');
      }
    } catch {
      toast({ title: 'Unexpected error', status: 'error', duration: 5000, isClosable: true });
      setDeleteUserStatus('idle');
    }
  }

  async function findBrokerageRequest() {
    const response = await fetch(
      `/api/brokerages?phrase=${brokerageFinderText}`,
      {
        method: "GET",
      }
    );
    const receivedData = await response.json();
    const { brokerageOptions } = receivedData;
    return brokerageOptions;
  }

  const { data: foundBrokerages, error: userError, status: brokerageStatus } = useQuery(
    ["brokerageFinder", brokerageFinderText],
    findBrokerageRequest,
    {
      refetchOnWindowFocus: false,
      enabled: !!brokerageFinderText,
      onSuccess: (data) => {
        if (!data) {
          throw "error";
          // setStatus("error");
        } 
      },
      onError: (error) => {
        clientError(error);
      },
    }
  );
  const messageHandler = () => {
    if (profile) {
      onOpen();
    }

    else {
      setMessageToSend(true);
      setAuthHeader(`Log in or sign up to message ${firstName}`)
      triggerAuth("Message agent")
    }
  }
  const uploadProfilePicture = (e) => {
    const theFile = e.target.files[0];

    if (theFile["size"] > 5000000) {
      swal("Large File", "Please select an image which is under 5MB", "info");
    } else {
      setPicUploadStatus("loading");
      // setProfilePictureFile(theFile)
      setProfilePictureURL(URL.createObjectURL(theFile));
      editStarter("profile picture");
      setPicUploadStatus("success");
    }
  };

  const uploadBrokeragePicture = (e) => {
    const theFile = e.target.files[0];

    if (theFile["size"] > 5000000) {
      swal("Large File", "Please select an image which is under 5MB", "info");
    } else {
      setPicUploadStatus("loading");
      // setBrokeragePictureFile(theFile)
      setBrokeragePictureURL(URL.createObjectURL(theFile));
      editStarter("brokerage photo");
      setPicUploadStatus("success");
    }
  };

  useEffect(() => {
    setAllowableScroll(
      userListings?.length > 0
        ? (userListings?.length + 1) * 240 * -1 + scroller.current.offsetWidth
        : 2
    );
  }, []);

  useEffect(() => {
    if (profile && messageToSend) {
      onOpen();
    }
  }, [profile])

  async function saveVisitRequest(visitData) {

    let IPAddress;
    try {
      const IPresponse = await fetch("https://jsonip.com", { mode: "cors" });
      const IPobj = await IPresponse.json();
      IPAddress = IPobj ? IPobj["ip"] : null;
    } catch (e) {
      clientError(e);
    }
    visitData["IPAddress"] = IPAddress;

    const response = await fetch("/api/visits/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: visitData }),
    });
    const data = await response.json();
    const { returnObj } = data;
    return returnObj;
  }

  const visitMutation = useMutation(saveVisitRequest, {
    onSuccess(data, variables, context) {
    },
    onError: (error) => {
      clientError(error);
    },
  });


  useEffect(() => {

    if (uid && !visitTracked && userId != uid) {
      if (!profile) {
        visitMutation.mutate({
          profileId: uid,
        });
      } else {
        visitMutation.mutate({
          profileId: uid,
          uid: userId,
        });

        setVisitTracked(true);
      }
    }

  }, [uid, profile])


  const updateUserRequest = async (passedData) => {
    setChangeStatus("loading");
    const response = await fetch(`/api/users/${uid}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
      body: JSON.stringify({ updatedData: passedData }),
    });

    const data = await response.json();
    const { user } = data;
    return user;
  };

  const editStarter = (content) => {
    setEditContent(content);
    setEditModalOpen(true);
  };

  const onEditClose = () => {
    setEditModalOpen(false);
  };

  const updateMutation = useMutation(updateUserRequest, {
    onError: (error) => {
      toast({
        title: "Error",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      clientError(error);
      setChangeStatus("error");
    },

    onSuccess: (data, variables, context) => {
      if (data) {
        // queryClient.invalidateQueries(userId);
        setProfileData(data);

        setChangeStatus("success");
        toast({
          title: `Successfully updated ${editContent.toProperCase()}.`,
          description: "Refresh page to see changes.",
          status: "success",
          duration: 5000,
          isClosable: true,
          variant: "subtle",
        });
        onClose();
        setEditModalOpen(false);
      } else {
        throw "error";
      }
    },
  });

  function EditableControls({ isEditing, onSubmit, onCancel, onRequestEdit }) {
    return isEditing ? (
      <ButtonGroup justifyContent="center" size="sm">
        <IconButton
          aria-label="check"
          icon={<CloseIcon />}
          onClick={onSubmit}
        />
        <IconButton
          aria-label="close"
          icon={<CloseIcon />}
          onClick={onCancel}
        />
      </ButtonGroup>
    ) : (
      <Flex justifyContent="center">
        <IconButton
          aria-label="edit"
          size="sm"
          icon={<EditIcon />}
          onClick={onRequestEdit}
        />
      </Flex>
    );
  }

  const triggerAuth = (hook) => {
    clientAnalytics.track("Sign up attempted", {
      hook,
    });
    // Mixpanel.track(hook);
    setIsAuthBoxOpen(true);
  };

  const onAuthBoxClose = () => {
    setIsAuthBoxOpen(false);
  };

  async function sendMessageRequest(messageData) {
    messageStatus == "loading" ? null : setMessageStatus("loading");
    const response = await fetch("/api/messages/create?scenario=O1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
      body: JSON.stringify({ message: messageData }),
    });

    const data = await response.json();
    return data;
  }

  const messageMutation = useMutation(sendMessageRequest, {
    onError: (error) => {
      // An error happened!
      clientError(error);
      setMessageStatus("error");
      setErrorMessage("An error has occured, please try again later");
    },

    onSuccess: (data, variables, context) => {
      if (data.theMessage) {
        const { theMessage } = data;
        const { convoId, senderEmail, senderPhone } = theMessage;
        setMessageStatus("success");
        setMessageToSend(false);
        toast({
          status: "success",
          title: "Message sent",
          variant: 'subtle',
          description: `Your message to ${fullName} was successfully sent`
        })
        clientAnalytics.track("DM to agent (client)", {
          route: 'Profile page'
        });

      }

      else if (data.specificError) {
        setMessageStatus('idle');
        setMessageToSend(false);
        toast({
          title: data.specificError,
          status: "warning",
          variant: "subtle",
          duration: 5000,
          isClosable: true,
        });
      }
      else {
        throw "An error occured trying to send DM";
      }
      isOpen && onClose();
    }
  });

  const leadSend = async (values) => {
    //
    messageMutation.mutate({
      message: messageText,
      uid: userId,
      recipient: uid
    });
  };

  String.prototype["toProperCase"] = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const MessageSchema = Yup.object().shape({
    message: Yup.string().max(1000, "Too long.").min(1, "Too short."),
  });

  let specializationArr = [];

  if (typeof specialization === "object") {
    specializationArr = specialization.map((piece) => {
      return piece.label;
    });
  }

  const messageBody = (
    <Flex flexDirection="column" alignItems="center">
      <Flex justifyContent="flex-start" marginBottom="25px" maxW="310px">
        <Avatar src={photoURL ? photoURL : ""} size="md" mr="10px" />

        <Flex flexDirection="column" justifyContent="center">
          <Flex alignItems="center">
            <SectionHeader>{fullName.toProperCase()}</SectionHeader>

            {pro && (
              <Badge ml="6px" variant="solid" colorScheme="green">
                Pro
              </Badge>
            )}
          </Flex>
          <Text>{title}</Text>
        </Flex>
      </Flex>

      {/* Visitors will be able to fill a form to message you directly here */}

      {userId === uid && (
        <Text textAlign="center" maxWidth="310px">
          Users will be able to fill a form to message you directly here.
        </Text>
      )}
      <Formik
        initialValues={{
          message: "",
        }}
        validationSchema={MessageSchema}
        onSubmit={async (values, { setSubmitting }) => {
          if (messageStatus !== "loading") {
            await setTimeout(() => {
              leadSend(values);
            }, 1000);

            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting, isValid, handleChange, values, handleSubmit }) => (
          <>
            {/* <Heading size="h3" noMargin marginBottom="10px">Contact {firstName}</Heading> */}

            {messageStatus !== "success" && (!userId || uid !== userId) && (
              <Flex justifyContent="center" alignItems="center">
                <form
                  className={styles.contactCardForm}
                  onSubmit={handleSubmit}
                >

                  <Field
                    type="string"
                    name="message"
                    // as='textarea'
                    label="Message"
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    // placeholder='Your message here'
                    component={MaterialTextarea}
                  />

                  <Button
                    type="submit"
                    bg={"brand.900"}
                    color={"white"}
                    _hover={{ bg: "brand.800" }}
                    isLoading={messageStatus === "loading"}
                    loadingText="Sending Message"
                    isDisabled={!isValid}
                  >
                    Send Message
                  </Button>
                </form>
              </Flex>
            )}

            {messageStatus === "success" && (
              <Box>
                <Alert status="success" variant="solid">
                  <AlertIcon />
                  Message sent to {firstName}
                </Alert>
              </Box>
            )}

            {messageStatus === "error" && (
              <Message error success={undefined} noShow={undefined}>
                {errorMessage}
              </Message>
            )}
          </>
        )}
      </Formik>
    </Flex>
  );

  // lower case slug should also work
  return (<>
    <Head>
      <title key="title">
        {fullName.toProperCase()} - {brokerage?.toProperCase()} - Zonado.com
      </title>
      <meta
        key="description"
        name="description"
        content={`Check out ${fullName.toProperCase()}'s agent profile on Zonado to view up-to-date listings, and contact information.`}
      />
      <meta
        key="og:title"
        property="og:title"
        content={`${fullName.toProperCase()} - ${brokerage?.toProperCase()} - Zonado.com`}
      />
      <meta
        key="og:description"
        property="og:description"
        content={`Check out ${fullName.toProperCase()}'s agent profile on Zonado to view up-to-date listings, and contact information.`}
      />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Zonado" />
      <link
        key="fav1"
        rel="apple-touch-icon"
        sizes="180x180"
        href="../../favicons/apple-touch-icon.png"
      />
      <link
        key="fav2"
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="../../../favicons/favicon-32x32.png"
      />
      <link
        key="fav3"
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="../../favicons/favicon-16x16.png"
      />
      <link
        key="fav4"
        rel="manifest"
        href="../../../favicons/site.webmanifest"
      />
      <link
        key="fav5"
        rel="mask-icon"
        href="../../favicons/safari-pinned-tab.svg"
        color="#5bbad5"
      />
      <link
        key="fav6"
        rel="shortcut icon"
        href="../../../favicons/favicon.ico"
      />
      <link rel="canonical" href={`https://zonado.com/profile/${router.query.slug}`} />
      <meta
        key="msFav"
        name="msapplication-config"
        content="../favicons/browserconfig.xml"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: fullName,
            url: `https://zonado.com/profile/${router.query.slug}`,
            sameAs: [facebook, instagram, linkedin, twitter, link],
          }),
        }}
      />
    </Head>
    <SideNav />
    <ProfileOverall>
      <ProfileWrap>
        {/* Top box, name, brokerage, CTAs */}

        <ContentBox>
          <Flex
            alignItems="center"
            justifyContent="space-between"
            flexDirection={{ base: "column", md: "row" }}
          >
            <Flex>
              <Box>
                <Avatar src={photoURL ? photoURL : ""} size="xl" mr="10px" />

              </Box>
              <Flex flexDirection="column" justifyContent="center">
                <Flex alignItems="center">
                  <UserName>{fullName.toProperCase()}</UserName>
                  {pro && (
                    <Badge ml="6px" variant="solid" colorScheme="green">
                      Pro
                    </Badge>
                  )}
                  {profile?.userRole === "admin" && adminWelcomeAssist !== null && (
                    <Button
                      ml="6px"
                      size="sm"
                      colorScheme={adminWelcomeAssist ? "green" : "gray"}
                      variant="outline"
                      onClick={async () => {
                        try {
                          const response = await fetch("/api/users/update", {
                            method: "PUT",
                            headers: {
                              "Content-Type": "application/json",
                              token: await getToken(),
                            },
                            body: JSON.stringify({
                              uid: uid,
                              welcomeAssist: !adminWelcomeAssist
                            }),
                          });
                          if (!response.ok) throw new Error("Failed to update user");
                          const data = await response.json();
                          setAdminWelcomeAssist(!adminWelcomeAssist);
                          // setProfileData({...profileData, welcomeAssist: !adminWelcomeAssist});
                          toast({
                            title: adminWelcomeAssist ? "Welcome Assist disabled" : "Welcome Assist enabled",
                            status: "success",
                            duration: 3000,
                            isClosable: true,
                          });
                        } catch (error) {
                          console.error("Error updating welcome assist:", error);
                          toast({
                            title: "Error updating Welcome Assist status",
                            status: "error", 
                            duration: 3000,
                            isClosable: true,
                          });
                        }
                      }}
                    >
                      Welcome Assist {adminWelcomeAssist ? "On" : "Off"}
                    </Button>
                  )}
                  {(userId == uid || profile?.userRole == "admin") && (
                    <IconButton
                      icon={<EditIcon />}
                      borderRadius={"20px"}
                      ml="0.5rem"
                      onClick={() => {
                        editStarter("details");
                      }}
                      colorScheme="green"
                      variant="outline"
                      size="sm" aria-label={"Edit name"} />
                  )}
                </Flex>
                <Text>
                  {title
                    ? brokerage
                      ? title + " at " + brokerage.toProperCase()
                      : title
                    : brokerage
                      ? brokerage
                      : ""}
                </Text>
              </Flex>
            </Flex>

            {brokeragePhoto && (
              <Box
                width="80px"
                position={"relative"}
                marginTop={{ base: "20px", md: "0px" }}
                marginBottom={{ base: "20px", md: "0px" }}
              >
                <Image src={brokeragePhoto} max-width="100%" height="100%" />
                {(
                  (userId == uid) ||
                  (profile?.userRole === 'brokerageAdmin' && brokerage && profile?.brokerage === brokerage) ||
                  profile?.userRole == "admin"
                ) && (
                    <>
                      <input
                        id="brokeragePhoto"
                        type="file"
                        onChange={uploadBrokeragePicture}
                        accept="image/x-png,image/jpeg, image/webp, image/png"
                        style={{ display: "none" }}
                      />

                      <Button
                        position="absolute"
                        bottom="-2.5rem"
                        left="1.5rem"
                        size="sm"
                        colorScheme="green"
                        variant="outline"
                        padding={"0px"}
                        // borderRadius={"20px"}
                      >
                        <PhotoLabel
                          htmlFor="brokeragePhoto"
                        >
                          Edit
                        </PhotoLabel>
                      </Button>
                    </>
                  )}
              </Box>
            )}

            {!brokeragePhoto &&
              (
                (userId == uid) ||
                (profile?.userRole == 'brokerageAdmin' && brokerage && brokerage === profile?.brokerage) ||
                profile?.userRole == "admin"
              ) &&
              (
                industryRole == "Realtor" ||
                industryRole == "Business Broker"
              ) && (
                <Box>
                  <input
                    id="brokeragePhoto"
                    type="file"
                    onChange={uploadBrokeragePicture}
                    accept="image/x-png,image/jpeg, image/webp, image/png"
                    style={{ display: "none" }}
                  />

                  <Button
                    marginTop={{ base: "4rem", md: "0rem" }}
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    borderRadius={"20px"}
                  >
                    <PhotoLabel
                      className={styles.labelButton}
                      htmlFor="brokeragePhoto"
                    >
                      Add brokerage photo
                    </PhotoLabel>
                  </Button>
                </Box>
              )}
          </Flex>

          {((userId == uid) || profile?.userRole == "admin") && (
            <Flex mt="16px"
              rowGap={4}
            >
              <input
                id="profilePicture"
                type="file"
                onChange={uploadProfilePicture}
                accept="image/x-png,image/jpeg, image/webp, image/png"
                style={{ display: "none" }}
              />

              <Button
                // position="absolute"
                // bottom="-2.5rem"
                // left="1.25rem"
                size="sm"
                colorScheme="green"
                variant="outline"
                // leftIcon={<AiFillPicture />}
                // borderRadius={"20px"}
              >
                <PhotoLabel
                  className={styles.labelButton}
                  htmlFor="profilePicture"
                >
                  Edit Photo
                </PhotoLabel>
              </Button>


            </Flex>
          )}
          {/* Call and Message buttons */}
          <Flex
            justifyContent="center"
            paddingTop={{ base: "15px", md: "25px" }}
          >
            <Box
              display="grid"
              // If we dont have the user's phone number then the grid will only have one column
              gridTemplateColumns="1fr"
              gridTemplateRows={{ base: "1fr 1fr", md: "1fr" }}
              gridColumnGap="25px"
              gridRowGap="15px"
              marginTop="10px"
            >
              {profile?.userRole == 'admin' && adminContactInfo?.phone && (
                <Button
                  variant="outline"
                  colorScheme="green"
                  color="green.500"
                  size="md"
                  onClick={() => setShowPhone(true)}
                >
                  {showPhone ? (
                    <a href={`tel:${adminContactInfo.phone}`}>
                      <NumberFormat
                        displayType={"text"}
                        value={adminContactInfo.phone}
                      />
                    </a>
                  ) : (
                    "View phone number"
                  )}
                </Button>
              )}
              {profile?.userRole == 'admin' && adminContactInfo?.email && (
                <Button
                  variant="outline"
                  colorScheme="blue"
                  color="blue.500"
                  size="md"
                  as="a"
                  href={`mailto:${adminContactInfo.email}`}
                >
                  {adminContactInfo.email}
                </Button>
              )}

              {/* Commenting this out since its broken */}
              {/* <Button variant="solid" bg={"brand.900"} color={"white"} _hover={{ bg: "brand.800" }} size="md"
                  onClick={messageHandler}
                        isDisabled={messageStatus === 'success'}
                        leftIcon={messageStatus === 'success' ? <CheckIcon /> : null}
                  >
                    {messageStatus === 'success' ? 'Messaged' : `Message ${firstName}`}</Button> */}
            </Box>
          </Flex>

          {profile?.userRole === 'admin' && adminLeadStats && (
            <Flex justifyContent="center" gap="8px" pt="12px" flexWrap="wrap">
              <Badge colorScheme="green" fontSize="0.8em" px="8px" py="4px" borderRadius="6px">
                {adminLeadStats.leadCount} lead{adminLeadStats.leadCount === 1 ? '' : 's'} received
              </Badge>
              <Badge
                colorScheme={adminLeadStats.pro ? 'purple' : 'gray'}
                fontSize="0.8em"
                px="8px"
                py="4px"
                borderRadius="6px"
              >
                {adminLeadStats.pro ? 'Pro' : 'Not pro'}
              </Badge>
              {!adminLeadStats.pro && adminLeadStats.everPro && (
                <Badge colorScheme="orange" fontSize="0.8em" px="8px" py="4px" borderRadius="6px">
                  Formerly pro
                </Badge>
              )}
            </Flex>
          )}

          {profile?.userRole === 'admin' && userId !== uid && (
            <Flex justifyContent="center" pt="16px">
              <Button
                colorScheme="red"
                size="sm"
                isLoading={deleteUserStatus === 'loading'}
                isDisabled={deleteUserStatus === 'done'}
                onClick={onDeleteUserOpen}
              >
                Delete User
              </Button>
            </Flex>
          )}
        </ContentBox>

        {/* About */}
        <ContentBox>
          <Flex justifyContent={"space-between"}>
            <SectionHeader>About Me</SectionHeader>

            {(userId == uid || profile?.userRole == "admin") && (
              <Button
                leftIcon={<EditIcon />}
                borderRadius={"20px"}
                onClick={() => {
                  editStarter("about");
                }}
                colorScheme="green"
                variant="outline"
                size="sm"
              >
                Edit
              </Button>
            )}
          </Flex>

          <Text whiteSpace="pre-line">
            {about
              ? about
              : brokerage && industryRole == "Realtor" 
                ? `${fullName.toProperCase()} is ${title ? `a ${title}` : "a Real Estate Agent"
                } with ${brokerage?.toProperCase().trim()}. ${userListings?.length > 0
                  ? `${firstName.toProperCase()} currently has ${userListings?.length
                  } ${userListings?.length > 1 ? "listings" : "listing"
                  } on Zonado.`
                  : ``
                }`
                : `${fullName.toProperCase()} is ${industryRole == "Investor" ? "an" : "a"
                } ${industryRole}. ${userListings?.length > 0
                  ? `${firstName.toProperCase()} currently has ${userListings?.length
                  } ${userListings?.length > 1 ? "listings" : "listing"
                  } on Zonado.`
                  : ``
                }`}
          </Text>

          {(userId == uid ||
            profile?.userRole == "admin") && (
              <Flex alignItems={"center"} mt="2rem">
                <Text>
                  <SmallFancyBold>Industry Role</SmallFancyBold> {industryRole == "Principal" ? "Owner/Investor" : industryRole || ""} {industryRole == 'Realtor' ? `- ${title} with ${brokerage}` : ''}
                </Text>

                {(userId == uid || profile?.userRole == "admin") && (
                  <Button
                    leftIcon={industryRole?.length > 0 ? <EditIcon /> : <AddIcon />}
                    borderRadius={"20px"}
                    onClick={() => {
                      editStarter("industryRole");
                    }}
                    colorScheme="green"
                    variant="outline"
                    size="sm"
                    ml="1rem"
                  >
                    {industryRole?.length > 0 ? "Edit" : "Add"}
                  </Button>
                )}
              </Flex>
            )}

          {(specialization?.length > 0 ||
            userId == uid ||
            profile?.userRole == "admin") && (
              <Flex alignItems={"center"} mt="2rem">
                <Text>
                  <SmallFancyBold>Specialization</SmallFancyBold>{" "}
                  {specialization.join(", ")}
                </Text>

                {(userId == uid || profile?.userRole == "admin") && (
                  <Button
                    leftIcon={<EditIcon />}
                    borderRadius={"20px"}
                    onClick={() => {
                      editStarter("specialization");
                    }}
                    colorScheme="green"
                    variant="outline"
                    size="sm"
                    ml="1rem"
                  >
                    Edit
                  </Button>
                )}
              </Flex>
            )}

          {(location?.length > 0 ||
            userId == uid ||
            profile?.userRole == "admin") && (
              <Flex alignItems={"center"} mt="2rem">
                <Text>
                  <SmallFancyBold>Location</SmallFancyBold> {location || ""}
                </Text>

                {(userId == uid || profile?.userRole == "admin") && (
                  <Button
                    leftIcon={location?.length > 0 ? <EditIcon /> : <AddIcon />}
                    borderRadius={"20px"}
                    onClick={() => {
                      editStarter("location");
                    }}
                    colorScheme="green"
                    variant="outline"
                    size="sm"
                    ml="1rem"
                  >
                    {location?.length > 0 ? "Edit" : "Add"}
                  </Button>
                )}
              </Flex>
            )}
        </ContentBox>

        {userListings?.length > 0 && (
          <ContentBox>
            <SectionHeader>Listings</SectionHeader>

            <Box marginTop="20px">
              <Flex
                ref={scroller}
                overflowX="auto"
                pb="4px"
              >
                {userListings?.map((listing) => (
                  <Link
                    key={listing.id}
                    href={`/listings/${encodeURIComponent(
                      listing.id
                    )}/${slugify(listing.subject.toProperCase())}`}
                  >

                    <RelevantListing {...listing} />

                  </Link>
                ))}

                {/* Only show right button if the number of listings exceeds the width */}
              </Flex>


              <Flex marginTop="30px" justifyContent="center">
                <Link
                  href={{
                    pathname: "/listings",
                    query: { user: uid, name: fullName },
                  }}>

                  <Button size="sm" colorScheme={"green"} variant={"solid"}>
                    View all listings
                  </Button>

                </Link>
              </Flex>
            </Box>
          </ContentBox>
        )}

        {/* Show empty listings box and get them to upload a listing if they're looking at their own profile */}
        {userListings?.length === 0 && userId === uid && (
          <ContentBox>
            <SectionHeader>Listings</SectionHeader>

            <Flex my="25px" w="100%" justifyContent="center">
              <Link href="/add-listing">

                <Button variant="solid" colorScheme="green" size="md">
                  Upload Your First Listing
                </Button>

              </Link>
            </Flex>
          </ContentBox>
        )}

        {/* Website Link */}
        {(facebook?.length > 10 ||
          twitter?.length > 10 ||
          linkedin?.length > 10 ||
          instagram?.length > 10 ||
          link?.length > 5 ||
          userId == uid ||
          profile?.userRole == "admin") && (
            <ContentBox>
              <Flex justifyContent={"space-between"}>
                <SectionHeader>Links</SectionHeader>

                {(userId == uid || profile?.userRole == "admin") && (
                  <Button
                    leftIcon={<EditIcon />}
                    borderRadius={"20px"}
                    onClick={() => {
                      editStarter("links");
                    }}
                    colorScheme="green"
                    variant="outline"
                    size="sm"
                  >
                    Edit
                  </Button>
                )}
              </Flex>
              {link && (
                <Link href={link.trim()} target="_blank" rel="noreferrer">

                  <Button
                    mb="16px"
                    variant="link"
                    colorScheme="black"
                    rightIcon={<ExternalLinkIcon />}
                  >
                    Visit {firstName.toProperCase() + "'s"} Website
                  </Button>

                </Link>
              )}

              <SocialLinks>
                {facebook?.length > 10 && (
                  <Link href={facebook.trim()} target="_blank">

                    <AiFillFacebook size="2rem" color="black" />

                  </Link>
                )}

                {twitter?.length > 10 && (
                  <Link href={twitter.trim()} target="_blank">

                    <AiFillTwitterSquare size="2rem" color="black" />

                  </Link>
                )}

                {instagram?.length > 10 && (
                  <Link href={instagram.trim()} target="_blank">

                    <AiFillInstagram size="2rem" color="black" />

                  </Link>
                )}

                {linkedin?.length > 10 && (
                  <Link href={linkedin.trim()} target="_blank">

                    <AiFillLinkedin size="2rem" color="black" />

                  </Link>
                )}
              </SocialLinks>
            </ContentBox>
          )}
      </ProfileWrap>
    </ProfileOverall>
    <AuthModal
      returnToListing
      onClose={onAuthBoxClose}
      isOpen={isAuthBoxOpen}
      header={authHeader}

    />
    {/* Modal */}
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      preserveScrollBarGap={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Message Agent</ModalHeader>
        <ModalCloseButton />
        <ModalBody>

          <Flex justifyContent="flex-start" marginBottom="25px" maxW="310px">
            <Avatar src={photoURL ? photoURL : ""} size="md" mr="10px" />

            <Flex flexDirection="column" justifyContent="center">
              <Flex alignItems="center">
                <Text
                  fontSize="1.3rem"
                  fontWeight="500"
                >{fullName.toProperCase()}</Text>

                {pro && (
                  <Badge ml="6px" variant="solid" colorScheme="green">
                    Pro
                  </Badge>
                )}
              </Flex>
              <Text>{title}</Text>
            </Flex>
          </Flex>

          <Textarea
            autoFocus
            value={messageText}
            placeholder="Your message here"
            onChange={(e) => setMessageText(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          {(messageText.length > 300 || messageText.length < 5) &&
            <Text
              color="tomato"
              mr="12px"
              fontSize="14px"
            >
              {messageText.length < 5 ? "Message too short" : messageText.length > 300 ? "Message too long" : null}
            </Text>
          }
          <ButtonGroup size="sm">
            <Button
              tabIndex={2}
              colorScheme="green"
              onClick={leadSend}
              type="button"
              isDisabled={messageStatus === 'loading' || messageText.length < 5 || messageText.length > 300}
              isLoading={messageStatus == "loading"}
              loadingText="Sending message..."
            >
              Send
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
    <Modal
      isOpen={editModalOpen}
      onClose={onEditClose}
      isCentered={true}
      closeOnOverlayClick={false}
      size={editContent == "about" ? "xl" : "md"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit {editContent == 'industryRole' ? 'Industry Role' : editContent?.toProperCase()}</ModalHeader>
        <ModalCloseButton />

        {editContent == "about" && (
          <Formik
            initialValues={{
              about: `${about || ""}`,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              updateMutation.mutate({
                about: values.about,
              });

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
            }) => (
              <>
                <ModalBody>
                  <Box>
                    <MyFormLabel htmlFor="about">About me</MyFormLabel>
                    <Field name="about">
                      {({ field, form }) => (
                        <Textarea
                          {...field}
                          height="300px"
                          {...form}
                          focusBorderColor="green.500"
                          id="about"
                          placeholder="Tell Zonado visitors a little about yourself and your experience to establish credibiility."
                          resize="vertical"
                        />
                      )}
                    </Field>
                    <Disclaimer>
                      Tip: the textbox can be expanded by dragging its bottom
                      right corner downwards.
                    </Disclaimer>
                  </Box>
                </ModalBody>

                <ModalFooter>
                  <Button
                    tabIndex={-1}
                    onClick={onEditClose}
                    mr={3}
                    size="sm"
                    variant="ghost"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleSubmit()}
                    isLoading={changeStatus === "loading"}
                    loadingText="Submitting"
                    size="sm"
                    colorScheme="green"
                    type="submit"
                    isDisabled={!isValid || isSubmitting}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </>
            )}
          </Formik>
        )}

        {editContent == "links" && (
          <Formik
            initialValues={{
              link: `${link || ""}`,
              facebook: `${facebook || ""}`,
              instagram: `${instagram || ""}`,
              linkedin: `${linkedin || ""}`,
              twitter: `${twitter || ""}`,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              const { link, ...rest } = values;
              updateMutation.mutate({
                ...rest,
                link:
                  values.link?.length > 0
                    ? values.link.slice(0, 4) === "http"
                      ? values.link
                      : "https://" + values.link
                    : values.link,
              });

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
            }) => (
              <>
                <ModalBody display={"grid"} gridRowGap="1rem">
                  <Box>
                    <MyFormLabel htmlFor="link">Website link</MyFormLabel>
                    <Field name="link">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="link"
                          placeholder="https://www.mywebsite.com"
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <MyFormLabel htmlFor="facebook">Facebook</MyFormLabel>
                    <Field name="facebook">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="facebook"
                          placeholder={`E.g. https://www.facebook.com/${fullName
                            .replace(" ", "")
                            .toLowerCase()}`}
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <MyFormLabel htmlFor="linkedin">LinkedIn</MyFormLabel>
                    <Field name="linkedin">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="linkedin"
                          placeholder={`E.g. https://www.linkedin.com/in/${fullName
                            .replace(" ", "")
                            .toLowerCase()}`}
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <MyFormLabel htmlFor="twitter">Twitter</MyFormLabel>
                    <Field name="twitter">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="twitter"
                          placeholder={`E.g. https://www.twitter.com/${fullName
                            .replace(" ", "")
                            .toLowerCase()}`}
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <MyFormLabel htmlFor="instagram">Instagram</MyFormLabel>
                    <Field name="instagram">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="instagram"
                          placeholder={`E.g. https://www.instagram.com/${fullName
                            .replace(" ", "")
                            .toLowerCase()}`}
                        />
                      )}
                    </Field>
                  </Box>
                </ModalBody>

                <ModalFooter>
                  <Button
                    tabIndex={-1}
                    onClick={onEditClose}
                    mr={3}
                    size="sm"
                    variant="ghost"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleSubmit()}
                    isLoading={changeStatus === "loading"}
                    loadingText="Submitting"
                    size="sm"
                    colorScheme="green"
                    type="submit"
                    isDisabled={!isValid || isSubmitting}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </>
            )}
          </Formik>
        )}

        {editContent == "details" && (
          <Formik
            initialValues={{
              firstName: `${firstName || ""}`,
              lastName: `${lastName || ""}`,
              brokerage: `${brokerage || ""}`,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              updateMutation.mutate({
                ...values,
                fullName: values["firstName"] + " " + values["lastName"],
              });

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
            }) => (
              <>
                <ModalBody display={"grid"} gridRowGap="1rem">
                  <Box>
                    <MyFormLabel htmlFor="firstName">First name</MyFormLabel>
                    <Field name="firstName">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="firstName"
                          placeholder="Roger"
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <MyFormLabel htmlFor="lastName">Last name</MyFormLabel>
                    <Field name="lastName">
                      {({ field, form }) => (
                        <Input
                          {...field}
                          {...form}
                          focusBorderColor="green.500"
                          id="lastName"
                          placeholder={`Bannister`}
                        />
                      )}
                    </Field>
                  </Box>

                  {(
                    
                    industryRole != "Realtor" &&
                    industryRole != "Business Broker"
                  ) && (
                    <Disclaimer>Hint: Trying to edit your brokerage name? Close this pop-up and you must first change your industry role to a "Realtor" or "Business Broker" first by using the edit button next to the Industry Role.</Disclaimer>
                  )}

                  {(
                    
                      industryRole == "Realtor" ||
                      industryRole == "Business Broker"
                    ) && (
                      <Box>
                        <MyFormLabel htmlFor="brokerage">Brokerage</MyFormLabel>
                        <Field name="brokerage">
                          {({ field, form }) => (
                            <Input
                              {...field}
                              {...form}
                              focusBorderColor="green.500"
                              id="brokerage"
                              placeholder={"Re/Max Platinum Realty Inc."}
                              isDisabled={profile?.userRole === 'brokerageAdmin'}
                            />
                          )}
                        </Field>
                      </Box>
                    )}
                </ModalBody>

                <ModalFooter>
                  <Button
                    tabIndex={-1}
                    onClick={onEditClose}
                    mr={3}
                    size="sm"
                    variant="ghost"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleSubmit()}
                    isLoading={changeStatus === "loading"}
                    loadingText="Submitting"
                    size="sm"
                    colorScheme="green"
                    type="submit"
                    isDisabled={!isValid || isSubmitting}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </>
            )}
          </Formik>
        )}

        {editContent == "specialization" && (
          <Formik
            initialValues={{
              specialization: specialization
                ? reactSelectOptionCreator(specialization)
                : [],
            }}
            onSubmit={async (values, { setSubmitting }) => {
              let cleanedArray = await createSimpleArray(
                values["specialization"]
              );
              updateMutation.mutate({
                specialization: cleanedArray,
              });

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
              setFieldValue,
            }) => (
              <>
                <ModalBody display={"grid"} gridRowGap="1rem">
                  <Box>
                    <MyFormLabel htmlFor="specialization">
                      Specialization
                    </MyFormLabel>
                    <Select
                      theme={selectTheme}
                      // value={values['specialization']}
                      name="specialization"
                      searchable
                      closeMenuOnSelect={false}
                      defaultValue={reactSelectOptionCreator(specialization)}
                      clearable
                      onChange={(e) => {
                        if (e) {
                          setFieldValue("specialization", e);
                        } else {
                          setFieldValue("specialization", []);
                        }
                      }}
                      isMulti
                      options={propertyTypeOptions}
                    />
                  </Box>
                </ModalBody>

                <ModalFooter>
                  <Button
                    tabIndex={-1}
                    onClick={onEditClose}
                    mr={3}
                    size="sm"
                    variant="ghost"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleSubmit()}
                    isLoading={changeStatus === "loading"}
                    loadingText="Submitting"
                    size="sm"
                    colorScheme="green"
                    type="submit"
                    isDisabled={!isValid || isSubmitting}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </>
            )}
          </Formik>
        )}

        {editContent == "industryRole" && (
          <Formik
            initialValues={{
              industryRole: industryRole,
              brokerage: brokerage
                ? brokerage
                : "",
              title: title ? title : "",
            }}
            onSubmit={async (values, { setSubmitting }) => {

              updateMutation.mutate(values);

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
              setFieldValue,
            }) => (
              <>
                <ModalBody display={"grid"} gridRowGap="1rem">
                  <MarginContainer>
                    <MyFormLabel htmlFor="industryRole">
                      Industry Role
                    </MyFormLabel>
                    <Select
                      theme={selectTheme}
                      // value={values['specialization']}
                      name="industryRole"
                      searchable
                      defaultValue={reactSelectOptionCreator([industryRole])}
                      onChange={(selectedOption) => {
                        handleChange("industryRole")(selectedOption.value);
                      }}
                      options={industryRoleOptions}
                    />
                  </MarginContainer>

                  {(values.industryRole === "Realtor" ||
                  values.industryRole === "Business Broker") && (
                  <>
                    <MarginContainer>
                      <MyFormLabel>Brokerage name</MyFormLabel>
                      <CreatableSelect
                        theme={selectTheme}
                        filterOption={(options, filter, current_values) => { return options; }}
                        name="brokerage"
                        onInputChange={(e) => {
                          e.length > 0 ? setBrokerageFinderText(e) : null;
                        }}
                        defaultValue={reactSelectOptionCreator([brokerage])}

                        onChange={(e) => {
                          handleChange("brokerage")(e.value);
                        }}
                        noOptionsMessage={() =>
                          brokerageStatus == 'loading'
                            ? "Loading"
                            : brokerageFinderText?.length < 1
                            ? "Begin typing"
                            : "No options"
                        }
                        // cacheOptions
                        // defaultOptions
                        options={foundBrokerages}
                      />
                     
                    </MarginContainer>

                    <MarginContainer>
                      <MyFormLabel>Title</MyFormLabel>
                      <Select
                      theme={selectTheme}
                      // value={values['specialization']}
                      name="title"
                      placeholder="Select title"
                      defaultValue={reactSelectOptionCreator([title])}
                      onChange={(selectedOption) => {
                        handleChange("title")(selectedOption.value);
                      }}
                      options={titleOptions}
                    />

                    </MarginContainer>
                  </>
                )}
                </ModalBody>

                <ModalFooter>
                  <Button
                    tabIndex={-1}
                    onClick={onEditClose}
                    mr={3}
                    size="sm"
                    variant="ghost"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => handleSubmit()}
                    isLoading={changeStatus === "loading"}
                    loadingText="Submitting"
                    size="sm"
                    colorScheme="green"
                    type="submit"
                    isDisabled={!isValid || isSubmitting}
                  >
                    Confirm
                  </Button>
                </ModalFooter>
              </>
            )}
          </Formik>
        )}

        {editContent == "location" && (
          <>
            <ModalBody display={"grid"} gridRowGap="1rem">
              <Box>
                {isLoaded && (
                  <CitySearch cityData={cityData} setCityData={setCityData} />
                )}
              </Box>
            </ModalBody>

            <ModalFooter>
              <Button
                tabIndex={-1}
                onClick={onClose}
                mr={3}
                size="sm"
                variant="ghost"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  updateMutation.mutate({
                    location: cityData["value"],
                  });
                }}
                isLoading={changeStatus === "loading"}
                loadingText="Submitting"
                size="sm"
                colorScheme="green"
                type="submit"
                isDisabled={!cityData["value"]}
              >
                Confirm
              </Button>
            </ModalFooter>
          </>
        )}

        {editContent == "profile picture" && (
          <>
            {picUploadStatus === "success" ? (
              <ImageCropper
                mutation={updateMutation}
                changeStatus={changeStatus}
                setChangeStatus={setChangeStatus}
                onClose={onClose}
                src={profilePictureURL}
                id={uid}
                fileName={"profilePicture"}
              ></ImageCropper>
            ) : (
              <Spinner size={"md"} />
            )}
          </>
        )}

        {editContent == "brokerage photo" && (
          <>
            {picUploadStatus === "success" ? (
              <ImageCropper
                mutation={updateMutation}
                changeStatus={changeStatus}
                setChangeStatus={setChangeStatus}
                onClose={onClose}
                src={brokeragePictureURL}
                id={uid}
                fileName={"brokeragePhoto"}
              ></ImageCropper>
            ) : (
              <Spinner size={"md"} />
            )}
          </>
        )}
      </ModalContent>
    </Modal>

    <AlertDialog
      isOpen={isDeleteUserOpen}
      leastDestructiveRef={deleteUserCancelRef}
      onClose={onDeleteUserClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete User Account
          </AlertDialogHeader>
          <AlertDialogBody>
            This will permanently delete <strong>{fullName}</strong>'s account and{' '}
            <strong>all associated data</strong> — listings, images, conversations, messages,
            saved searches, and all other records. This{' '}
            <strong>cannot be undone</strong>.
          </AlertDialogBody>
          <AlertDialogFooter gap="8px">
            <Button ref={deleteUserCancelRef} onClick={onDeleteUserClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleDeleteUser} ml={3}>
              Yes, Delete Everything
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  </>);
};

export default profileComponent;